import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { EeocFormComponent } from '../eeoc-form/eeoc-form.component';
import { Option } from '../../web-components/dropdown-box/dropdown-box.component';
import { CheckboxComponent } from '../../web-components/checkbox/checkbox.component';

@Component({
    selector: 'app-eeoc-form-us',
    templateUrl: './eeoc-form-us.component.html',
    styleUrls: ['./eeoc-form-us.component.scss'],
    standalone: false
})
export class EeocFormUsComponent extends EeocFormComponent implements OnInit {
  genderOptions: Option[] | undefined;
  ethnicityOptions: Option[];
  ageGroupOptions: Option[];
  @ViewChildren('veteranCheckbox') veteranCheckboxesUS: QueryList<CheckboxComponent>;

  updateSelectOptions(): void {
    this.genderOptions = this.genders.map(gender => {
      if (gender.id !== this.GENDER_DID_NOT_DISCLOSE_ID && gender.id !== this.GENDER_OTHER_ID) {
        return new Option(gender.id, gender.description);
      } else if (gender.id === this.GENDER_DID_NOT_DISCLOSE_ID) {
        return new Option(gender.id, String(this.translateService.instant('eeoc-form.do-not-wish-to-answer')));
      } else if (gender.id === this.GENDER_OTHER_ID) {
        return new Option(gender.id, String(this.translateService.instant('eeoc-form.gender_other')));
      }
    });

    this.ethnicityOptions = this.ethnicityList.map(ethnicity => {
      if (ethnicity.id !== this.ETHNICITY_DID_NOT_DISCLOSE_ID && ethnicity.id !== this.ETHNICITY_OTHER_ID) {
        return new Option(ethnicity.id, ethnicity.description);
      } else if (ethnicity.id === this.ETHNICITY_DID_NOT_DISCLOSE_ID) {
        return new Option(ethnicity.id, String(this.translateService.instant('eeoc-form.do-not-wish-to-answer')));
      } else if (ethnicity.id === this.ETHNICITY_OTHER_ID) {
        return new Option(ethnicity.id, String(this.translateService.instant('eeoc-form.ethnicity_other')));
      }
    });

    this.ageGroupOptions = this.ageGroupList.map(ageGroup => {
      return new Option(ageGroup.id, ageGroup.description);
    });
  }

  validateForm() {
    Object.keys(this.formGroup.controls).forEach(key => this.formGroup.get(key).updateValueAndValidity());
  }
}
